import { Text } from '@chakra-ui/react'
import { CatalogoBasePage, type ColumnConfig, type FieldConfig } from '../../../components/CatalogoBasePage'
import { motivosPausaService } from '../../../api/services'
import type { LookupItem } from '../../../api/models/maestros.models'
import { themeColors } from '../../../theme'

const columns: ColumnConfig<LookupItem>[] = [
  { header: 'ID', render: (i) => <Text fontFamily="monospace" fontSize="sm" color={themeColors.textSecondary}>{i.id}</Text> },
  { header: 'Descripción', render: (i) => <Text fontSize="sm" color={themeColors.text}>{i.description}</Text> },
]

const fields: FieldConfig<LookupItem>[] = [
  { name: 'description', label: 'Descripción', type: 'text', required: true, colSpan: 2 },
]

export default function MotivosPausaPage() {
  return (
    <CatalogoBasePage<LookupItem, number>
      title="Motivos de Pausa"
      subtitle="Catálogo de motivos de pausa (lookup)"
      entityName="motivo de pausa"
      service={motivosPausaService as never}
      columns={columns}
      fields={fields}
      keyExtractor={(i) => String(i.id)}
      idExtractor={(i) => i.id}
      isLookupOnly
      searchPlaceholder="Buscar..."
      updatePermission="masters.write"
    />
  )
}
